import { Field } from 'formik'
import React from 'react'

import { Select } from '@fourthwall/components'

import { useBespokeProductsQuery } from '../hooks/useBespokeProductsQuery'

type ProductBespokeProductIdProps = {
  bespokeProductId?: string
}

export const ProductBespokeProductId = ({ bespokeProductId }: ProductBespokeProductIdProps) => {
  const { bespokeProducts } = useBespokeProductsQuery()

  const options = bespokeProducts?.map((product) => ({
    label: `${product.name} (${product.id})`,
    value: product.id,
  }))

  return (
    <div style={{ marginTop: 8 }}>
      {bespokeProducts && (
        <Field
          component={Select}
          name="bespokeProductId"
          label="Bespoke Product"
          options={options}
          value={bespokeProductId}
        />
      )}
    </div>
  )
}
